import { resolveIconHref } from "../resolve-icon.js";
import type { CSSProperties } from "react";
import { tv } from "tailwind-variants";

type SpriteIconProps = {
	icon: string;
	className?: string;
	style?: CSSProperties;
};

export const spriteIcon = tv({
	base: ["icon"],
});

export default function UmbBtnSpriteIcon({
	icon,
	className,
	style,
}: SpriteIconProps) {
	return (
		<svg
			className={spriteIcon({
				className,
			})}
			style={style}
			aria-hidden="true"
		>
			<use
				href={resolveIconHref(icon)}
			/>
		</svg>
	);
}
